var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Map extends Component {
    constructor() {
        super('Map', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.module-map__branch-dot').on('click', (event, button) => {
                event.preventDefault();
                $('.module-map__branch-informations').removeClass('pe-auto').addClass('opacity-0 pe-none');
                if (button.hasClass('module-map__branch-informations__close')) {
                    $('.module-map__branch-dot').removeClass('is-active');
                    return;
                }
                if (!button.hasClass('is-active')) {
                    button.addClass('is-active');
                    $(`${button.attr('href')}`).removeClass('opacity-0 pe-none').addClass('pe-auto');
                }
                else {
                    button.removeClass('is-active');
                }
            });
            this.success();
        });
    }
}
